export default "__VITE_ASSET__CcX0eE7i__"